import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-412e6b68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pr-2" }
const _hoisted_2 = { class: "w-[37.7rem] h-[40rem] self-center" }
const _hoisted_3 = { class: "text-v_dark_blue" }
const _hoisted_4 = { class: "mt-5 text-v_dark_gray text-left font-[700]" }
const _hoisted_5 = { class: "flex justify-between items-center mt-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "opacity-[50%]" }, "à", -1))
const _hoisted_7 = {
  key: 0,
  class: "flex justify-between items-center text-v_dark_gray mt-5"
}
const _hoisted_8 = { class: "text-v_dark_gray mt-4" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "text-v_dark_gray mt-4" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "mt-10 flex justify-between items-center" }

import {
	ModalContainer,
	H1,
	H2,
	Input,
	Select,
	ModalButton,
	ModalCloseButton,
	ModalContentContainer,
} from "@/components/atoms"
import {
	COMPANIES,
	Notification,
	Permission,
	Situations,
	Bases,
	Status,
} from "@/utils/enum"
import { hasPermission } from "@/utils/permissions"
import { ref, reactive } from "vue"
import { getCommission } from "@/repositories/commissions"
import { useStore } from "@/store"
import {
	SAVE_COMISSION_FILTER,
	SAVE_RESALE_CODE,
	SELECTED_COMPANY,
} from "@/store/mutationsTypes"
import { onMounted } from "vue"
import {
	IBases,
	IBasesValidate,
	ISituation,
	IStatusValidate,
} from "@/utils/interfaces"


export default /*#__PURE__*/_defineComponent({
  __name: 'CommissionModal',
  emits: [
	"closeModal",
	"getCommissions",
	"showLoading",
	"emitError",
	"resaleCodes",
	"situation",
	"showSituation",
	"clearTable",
	"selectedBase",
],
  setup(__props, { emit }) {



let showButton = ref(false)
let company = ref("")
let situation = ref("")
const store = useStore()

store.commit(SELECTED_COMPANY, company)

const companies = [
	COMPANIES.PRIME_MG,
	COMPANIES.PRIME_PR,
	COMPANIES.PRIME_SC,
	COMPANIES.RB_CODE_BRANCH,
	COMPANIES.RB_CODE_HEADQUARTERS,
]

const situations = [
	Situations.FUTURE_COMMISSIONS,
	Situations.AVAILABLE_COMMISSIONS,
	Situations.GRADES_SENT,
	Situations.COMMISSIONS_PAID,
]

const commission: any = reactive({
	initialDate: "",
	finalDate: "",
	codRev: "",
	client: "",
	base: "",
	situation: "",
	pageNum: 1,
	pageSize: 10,
})

const validateBase = (base: keyof IBases) => {
	const Bases: IBases = {
		INTERWAY: COMPANIES.PRIME_MG,
		INTERWAYPR: COMPANIES.PRIME_PR,
		INTERWAYSC: COMPANIES.PRIME_SC,
		PRIME: COMPANIES.RB_CODE_BRANCH,
		PRIMESP: COMPANIES.RB_CODE_HEADQUARTERS,
		"": "",
	}

	return Bases[base]
}

const validadeStatus = (status: keyof ISituation) => {
	const situation: ISituation = {
		PAGAS: Situations.COMMISSIONS_PAID,
		ENVIADAS: Situations.GRADES_SENT,
		DISPONIVEIS: Situations.AVAILABLE_COMMISSIONS,
		FUTURAS: Situations.FUTURE_COMMISSIONS,
		"": "",
	}

	return situation[status]
}

const baseValidity = (base: keyof IBasesValidate) => {
	const bases: IBasesValidate = {
		"Prime Interway MG": Bases.INTERWAY,
		"Prime Interway PR": Bases.INTERWAYPR,
		"Prime Interway SC": Bases.INTERWAYSC,
		"RB Code Matriz": Bases.PRIME,
		"RB Code Filial": Bases.PRIMESP,
	}
	return bases[base]
}

const statusValidity = (status: keyof IStatusValidate) => {
	const situation: IStatusValidate = {
		"Comissões futuras": Status.FUTURE,
		"Comissões disponíveis": Status.AVAILABLE,
		"Notas enviadas": Status.SENT,
		"Comissões pagas": Status.PAID,
	}

	return situation[status]
}

const baseAndSituationParse = () => {
	let validate = false

	commission.base = baseValidity(company.value as keyof IBasesValidate)
	commission.situation = statusValidity(
		situation.value as keyof IStatusValidate
	)

	if (situation.value != "" && company.value != "") validate = true

	if (hasPermission([Permission.ADMIN]) && validate) {
		showButton.value = true
	} else if (hasPermission([Permission.RESALE]) && validate) {
		showButton.value = true
	} else {
		showButton.value = false
	}
}

const getCommissionAdmim = async () => {
	emit("showLoading", true)

	store.commit(SAVE_COMISSION_FILTER, commission)

	const res = await getCommission(commission)

	if (res?.status === 200) {
		emit("getCommissions", res.message)
		emit("showSituation", situation.value)
	} else if (res?.status == 404) {
		emit(
			"emitError",
			true,
			Notification.TITLE_COMMISSION_NOT_FOUND,
			`${Notification.SUBTITLE_COMMISSION_NOT_FOUND} ${String(
				commission.situation
			).toLowerCase()}`
		)
		emit("clearTable")
	} else if (res?.response.status == 500) {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
		emit("clearTable")
	}

	emit("closeModal", false)
	emit("showLoading", false)
}

const saveCommissionInfoInStore = () => {
	let resaleCodes = ""

	const codRev = store.getters.getCodRev

	commission.codRev = codRev

	store.commit(SAVE_COMISSION_FILTER, commission)

	if (
		commission.base == "INTERWAY" ||
		commission.base == "INTERWAYPR" ||
		commission.base == "INTERWAYSC"
	) {
		resaleCodes = store.getters.getCodAidc
	} else {
		resaleCodes = store.getters.getCodRbcode
	}

	store.commit(SAVE_RESALE_CODE, resaleCodes)
}

const getCommissionResale = async () => {
	emit("showLoading", true)
	saveCommissionInfoInStore()
	emit("selectedBase", commission.base, commission.codRev)

	const res = await getCommission(commission)
	if (res?.status === 200) {
		emit("getCommissions", res.message)
		emit("situation", commission.situation)
		emit("showSituation", situation.value)
	} else if (res?.status == 404) {
		emit(
			"emitError",
			true,
			Notification.TITLE_COMMISSION_NOT_FOUND,
			`${Notification.SUBTITLE_COMMISSION_NOT_FOUND} ${String(
				commission.situation
			).toLowerCase()}`
		)
		emit("clearTable")
	} else if (res?.response.status >= 500) {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
		emit("clearTable")
	}

	emit("closeModal", false)
	emit("showLoading", false)
}

const getCommissions = async () => {
	if (showButton.value) {
		if (hasPermission([Permission.ADMIN])) {
			getCommissionAdmim()
		}

		if (hasPermission([Permission.RESALE])) {
			getCommissionResale()
		}
	}
}

const validateBaseAndStatus = (base: string, status: string) => {
	company.value = validateBase(base as keyof IBases)
	situation.value = validadeStatus(status as keyof ISituation)
	if (company.value != "" && situation.value != "") {
		commission.base = base
		commission.situation = status
		showButton.value = true
	}
}

onMounted(() => {
	const filter = store.getters.getCommissionFilter

	commission.initialDate = filter.initialDate
	commission.finalDate = filter.finalDate
	commission.codRev = filter.codRev
	commission.client = filter.client

	validateBaseAndStatus(filter.base, filter.situation)
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), {
        width: 20,
        height: 5
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "px-2 py-2 float-right w-8 active:scale-90",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal', false)))
            }, [
              _createVNode(_component_v_icon, { icon: "mdi-close-thick" })
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(H1), null, {
                default: _withCtx(() => [
                  _createTextVNode("Comissão")
                ]),
                _: 1
              }),
              _createVNode(_unref(H2), { class: "text-black opacity-[50%] ml-[-0.8rem]" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Preencha todos os campos corretamente para concluir a pesquisa ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                default: _withCtx(() => [
                  _createTextVNode("Período:")
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Input), {
                  type: "date",
                  required: "",
                  modelValue: commission.initialDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((commission.initialDate) = $event)),
                  width: "20rem"
                }, null, 8, ["modelValue"]),
                _hoisted_6,
                _createVNode(_unref(Input), {
                  type: "date",
                  required: "",
                  modelValue: commission.finalDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((commission.finalDate) = $event)),
                  width: "20rem"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_unref(hasPermission)([_unref(Permission).ADMIN]))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Código Revenda:")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Input), {
                      type: "text",
                      class: "mt-2",
                      modelValue: commission.codRev,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((commission.codRev) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cliente:")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Input), {
                      type: "text",
                      class: "mt-2",
                      modelValue: commission.client,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((commission.client) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                default: _withCtx(() => [
                  _createTextVNode("Empresa:")
                ]),
                _: 1
              }),
              _createVNode(_unref(Select), {
                width: "0.4rem",
                name: "select",
                class: "mt-2",
                modelValue: _unref(company),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(company) ? (company).value = $event : company = $event)),
                onChange: baseAndSituationParse
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(companies, (item, index) => {
                    return _createElementVNode("option", {
                      value: item,
                      key: index
                    }, _toDisplayString(item), 9, _hoisted_9)
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                default: _withCtx(() => [
                  _createTextVNode("Situação:")
                ]),
                _: 1
              }),
              _createVNode(_unref(Select), {
                width: "0.4rem",
                name: "select",
                class: "mt-2",
                modelValue: _unref(situation),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(situation) ? (situation).value = $event : situation = $event)),
                onChange: baseAndSituationParse
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(situations, (item, index) => {
                    return _createElementVNode("option", {
                      value: item,
                      key: index
                    }, _toDisplayString(item), 9, _hoisted_11)
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(ModalCloseButton), {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('closeModal', false))),
                class: "active:scale-90"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              }),
              _createVNode(_unref(ModalButton), {
                onClick: getCommissions,
                enableButton: _unref(showButton),
                class: "active:scale-90"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Pesquisar ")
                ]),
                _: 1
              }, 8, ["enableButton"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})